module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-17.285705e5.png";